// extracted by mini-css-extract-plugin
module.exports = {"label":"Home_label__I2mJL"};